export default {
  authorizedRedirections: [
    /^\/$/,
    /^\/publish/,
    /^\/login/,
    /^\/explorer/,
    /^\/portal/,   
    /^\/maps/,
    /^\/oidc/,
    /^https:\/\/geoservices-test.geofit.fr/,
    /^https:\/\/geoservices.geofit.fr/,
    /^https:\/\/safie-qualif.kermap.com/,
    /^https:\/\/safie.kermap.com/,
  ],
  customHeaderAndFooter: true,
  client: {
    name: "Neogeo",
    email: "contact@neogeo.fr"
  },
  forms: {
    signin: {
      title: {
        en: "Enter your login",
        fr: "Merci de vous connecter",
      }
    },
    signup: {
      disabled: true,
      hiddenFields: [],
      requiredFields: [
        'first_name',
        'last_name',
        'email',
      ],
    },
    organisation: {
      hiddenFields: [],
      requiredFields: [
        'display_name',
        'organisation_type',
      ],
    },
  }
};
